export const setUsername = (state, username) => {
  state.user.username = username;
};

export const setOldPassword = (state, oldPassword) => {
  state.user.oldPassword = oldPassword;
};

export const setAdmin = (state, isAdmin) => {
  state.isAdmin = isAdmin;
};

export const setUser = (state, user) => {
  state.user = user;
};

export const setEmail = (state, email) => {
  state.user.email = email;
};
